export const STATE_COLORS = {
  New: 'neutral',
  Sent: 'primary',
  Submitted: 'success',
  Reopened: 'warning'
};

/** Shared pill colors used by state / link / type / outcome chips. */
export const CHIP_TONES = {
  primary: { color: '#163CE9', background: '#EEF1FE', border: '#D0D8FB' },
  success: { color: '#0F7A3C', background: '#E7F6EE', border: '#C6E9D5' },
  warning: { color: '#995C00', background: '#FFF5E5', border: '#FFEACC' },
  danger: { color: '#B42318', background: '#FEF3F2', border: '#FECDCA' },
  neutral: { color: '#4D4D4D', background: '#F5F5F5', border: '#EBEBEB' },
  muted: { color: '#9E9E9E', background: '#FAFAFA', border: '#EBEBEB' }
};

export const linkChipTone = status => {
  if (status === 'Expired') return 'danger';
  if (status === 'Sent') return 'primary';
  if (status === 'Not sent') return 'muted';
  return 'neutral';
};

export const typeChipTone = isPilot => (isPilot ? 'primary' : 'neutral');

export const outcomeChipTone = ({ isPilot, outcome, pilotStatus } = {}) => {
  if (isPilot) {
    if (pilotStatus === 'closed_lost') return 'danger';
    if (pilotStatus === 'closed_won' || pilotStatus === 'closed') return 'success';
    if (pilotStatus === 'open') return 'primary';
    return 'neutral';
  }
  if (outcome === 'live') return 'success';
  return 'warning';
};

export const STATE_OPTIONS = [
  'All states',
  'New',
  'Sent',
  'Submitted',
  'Reopened'
].map(v => ({
  label: v,
  value: v
}));

export const TYPE_OPTIONS = ['All types', 'Pilot', 'Existing customer'].map(v => ({
  label: v,
  value: v
}));

export const OUTCOME_OPTIONS = [
  'All outcomes',
  'Pilot: open',
  'Pilot: closed won',
  'Pilot: closed lost',
  'Awaiting adoption',
  'Live'
].map(v => ({
  label: v,
  value: v
}));

export const DATE_OPTIONS = ['Last 30 days', 'Last 90 days', 'This quarter', 'All time'].map(v => ({
  label: v,
  value: v
}));

export const ALL_USERS_OPTION = { label: 'All internal users', value: 'All internal users' };
